export const website = {
  firstStep: {
    title: "Vamos começar! Qual modelo você gostaria de usar?",
    subtitle:
      "Pronto para criar um site incrível? Vamos começar pelos modelos; depois passamos para as cores.",
  },
  secondStep: {
    title: "Qual faixa de cores combina melhor com a sua marca?",
    subtitle: "Personalize seu modelo com um toque de cor",
  },
  thirdStep: {
    title: "Você tem ótimas fotos da sua propriedade?",
    titleLine2: "Envie-as!",
    subtitle: "Envie a melhor foto da sua propriedade para a página inicial",
  },
  fourthStep: {
    title: "Ótimo. Que tal um nome para o seu negócio?",
    subtitle:
      "O nome e o slogan de uma empresa aumentam o reconhecimento e reforçam a imagem da sua marca.",
  },
  fifthStep: {
    title: "Você tem um logo para a sua marca?",
    subtitle:
      "Para melhores resultados, use um design vetorial ou um PNG com fundo transparente. As proporções ideais são 2:1 ou 1:1 (imagem quadrada). O tamanho deve ser 400px x 192px (altura mín. 60px). Se você ainda não tem um logo, usaremos o nome do seu negócio como marca.",
  },
  livingstone: {
    navMain: "Menu principal",
    navProperty: "Propriedade",
    navMap: "Mapa",
    navGallery: "Galeria",
    navRates: "Tarifas",
    navAvailability: "Disponibilidade",
    navReviews: "Avaliações",
    bookNow: "Reserve agora",
    checkinCheckout: "Chegada → Saída",
    guests: "Hóspedes",
  },
  tideway: {
    navMain: "Menu principal",
    navProperty: "Propriedade",
    navMap: "Mapa",
    navGallery: "Galeria",
    navRates: "Tarifas",
    navAvailability: "Disponibilidade",
    navReviews: "Avaliações",
    bookNow: "Reserve agora",
    checkinCheckout: "Chegada → Saída",
    guests: "Hóspedes",
  },
};
